import { __rest, __assign, __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { styled } from '@mui/material/styles';
import ZigInput, { ZigInputInteractiveAdornmentStyle } from '../../inputs/ZigInput/index.js';
import { InputAdornment } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import copy from 'copy-to-clipboard';

var ZigCopyText = styled(function (_a) {
    var onCopied = _a.onCopied, copyElementId = _a.copyElementId, InputProps = _a.InputProps, props = __rest(_a, ["onCopied", "copyElementId", "InputProps"]);
    var doCopy = function () {
        onCopied === null || onCopied === void 0 ? void 0 : onCopied();
        copy(props.value);
    };
    return (React__default.createElement(ZigInput, __assign({ wide: true }, props, { InputProps: __assign(__assign({}, InputProps), { endAdornment: (React__default.createElement(InputAdornment, { position: "end" },
                React__default.createElement(ContentCopyIcon, { id: copyElementId, onClick: doCopy, width: 40, height: 40, sx: ZigInputInteractiveAdornmentStyle }))) }), readOnly: true })));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .MuiInput-root {\n    &,\n    & .MuiInput-input {\n      cursor: default;\n    }\n\n    &,\n    &.Mui-focused,\n    &:hover {\n      border-color: ", " !important;\n    }\n  }\n"], ["\n  .MuiInput-root {\n    &,\n    & .MuiInput-input {\n      cursor: default;\n    }\n\n    &,\n    &.Mui-focused,\n    &:hover {\n      border-color: ", " !important;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral700;
});
var templateObject_1;

export { ZigCopyText as default };
